import { getQueryParamsForScrollAndFocus } from '@/components/ux/hooks/use-scroll-and-focus';
import { urlWithFragment, urlWithQueryParams } from '@/hooks/use-go-to-deal';
import { getInformativePathname } from '@/hooks/use-redirect-to-informative-deal-url';
import { dealStore } from '@/models/stores';
import type { Comment } from '@/models/types';

export const useGetDealCommentUrl = (dealId: string, comment: Comment) => {
  const deal = dealStore.getById(dealId);
  const dealShortId = deal?.short_id;

  if (!dealShortId) {
    return;
  }

  if (!deal) {
    return;
  }
  if (!deal.vehicle_listing) {
    return;
  }

  const newPathname = getInformativePathname({
    primaryCustomerFullName: deal.primary_customer?.full_name || '',
    vehicle: deal.vehicle_listing,
    primarySalesRep: deal.primary_sales_rep,
    secondarySalesRep: deal.secondary_sales_rep,
    shortId: dealShortId,
    fallbackToUninformativePathname: true,
  });

  if (!newPathname) {
    return;
  }

  const queryParams = getQueryParamsForScrollAndFocus({
    uiType: 'comment',
    id: comment.id,
  });

  const newUrl = urlWithQueryParams(
    urlWithFragment(newPathname, undefined),
    queryParams,
  );

  return `${window.location.origin}/${newUrl}`;
};
